'use client';

import React from 'react';
import dynamic from 'next/dynamic';
import AddressSearchInputFallbackForm from '@/components/forms/AddressSearchInputFallbackForm';
import { useScheduler } from '../SchedulerContext';

const LottieHouseWaiting = dynamic(() => import('./LottieHouseWaiting'), {
  ssr: false, // Disable server-side rendering
});

export default function PropertyFinder() {
  const { address, setAddress, jwtToken, company } = useScheduler();

  return (
    <div className='mx-auto flex max-w-5xl flex-col items-center justify-center py-2'>
      <h3>Property Information</h3>
      <p className='mb-8'>
        To get started, search for the property below or enter the address
        manually
      </p>
      <div className='w-full sm:w-3/4'>
        <AddressSearchInputFallbackForm
          address={address}
          setAddress={setAddress}
          accessToken={jwtToken}
          proximity={
            company?.address?.lat && company?.address?.lng
              ? { lat: company.address.lat, lng: company.address.lng }
              : undefined
          }
        />
      </div>

      <LottieHouseWaiting />
    </div>
  );
}
